import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#4aa7bc',
        secondary: '#4aa7bc',
        dark:'#0f171f'
      },
    },
  },
});
